import { Component } from '@angular/core';

@Component({
  selector: 'app-tokenomics',
  templateUrl: './tokenomics.component.html',
  styleUrls: ['./tokenomics.component.scss'],
  standalone: false
})
export class TokenomicsComponent {
  items1 = [
    {
      title: 'tokenomics.toke_2',
      per: 'tokenomics.toke_2_per',
      amount: 'tokenomics.toke_2_amount',
      img: 'marketing-icon.webp',
      alt: 'marketing-icon',
    },
    {
      title: 'tokenomics.toke_1',
      per: 'tokenomics.toke_1_per',
      amount: 'tokenomics.toke_1_amount',
      img: 'development-icon.webp',
      alt: 'development-icon',
    },

    {
      title: 'tokenomics.toke_5',
      per: 'tokenomics.toke_5_per',
      amount: 'tokenomics.toke_5_amount',
      img: 'liquidity-icon.webp',
      alt: 'liquidity-icon',
    },

    {
      title: 'tokenomics.toke_4',
      per: 'tokenomics.toke_4_per',
      amount: 'tokenomics.toke_4_amount',
      img: 'reward-icon.webp',
      alt: 'reward',
    },
  ];

  items2 = [
    {
      title: 'tokenomics.toke_3',
      per: 'tokenomics.toke_3_per',
      amount: 'tokenomics.toke_3_amount',
      img: 'airdrop.webp',
      alt: 'airdrop-icon',
    },
    {
      title: 'tokenomics.toke_6',
      per: 'tokenomics.toke_6_per',
      amount: 'tokenomics.toke_6_amount',
      img: 'community-reward.webp',
      alt: 'community-reward-icon',
    },
    {
      title: 'tokenomics.toke_7',
      per: 'tokenomics.toke_7_per',
      amount: 'tokenomics.toke_7_amount',
      img: 'treasure-icon.webp',
      alt: 'treasure-icon',
    },
    {
      title: 'tokenomics.toke_8',
      per: 'tokenomics.toke_8_per',
      amount: 'tokenomics.toke_8_amount',
      img: 'creator-reward.webp',
      alt: 'creator-reward',
    },
  ];
}
